import { ExtensionType, extensions } from "@pixi/core";
const detectWebp = {
  extension: {
    type: ExtensionType.DetectionParser,
    priority: 0
  },
  test: async () => {
    const webpData = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=";
    return new Promise((resolve) => {
      const webp = new Image();
      webp.onload = () => {
        resolve(!0);
      }, webp.onerror = () => {
        resolve(!1);
      }, webp.src = webpData;
    });
  },
  add: async (formats) => [...formats, "webp"],
  remove: async (formats) => formats.filter((f) => f !== "webp")
};
extensions.add(detectWebp);
export {
  detectWebp
};
//# sourceMappingURL=detectWebp.mjs.map
